import React from 'react';
import { ContractInfo } from 'api/types/httpsTypes/contracts';
import { EditDWallet } from '../../Sections/EditDWallet';
import { SelectDWallet } from '../../Sections/SelectDWallet';
import { BuyAmount } from '../../Sections/BuyAmount';
import { TakeProfit } from '../../Sections/TakeProfit';
import { SafetyMeasures } from '../../Sections/SafetyMeasures';

export function TradeForm({
  cta,
  sniped,
  contract,
  isEdit,
}: {
  cta: React.ReactNode;
  sniped: boolean;
  contract?: ContractInfo;
  isEdit?: boolean;
}) {
  return (
    <div className="xxs:space-y-2 lg:space-y-1 lg:grow lg:flex ">
      <div className="xxs:space-y-0 lg:space-y-1 grow flex flex-col">
        {isEdit ? (
          <EditDWallet disabled={sniped} />
        ) : (
          <SelectDWallet disabled={sniped} />
        )}
        <BuyAmount disabled={sniped} contract={contract} />
        <TakeProfit />
        <div className="hidden lg:block">{cta}</div>
        <SafetyMeasures disabled={sniped} />
      </div>
      <div className="lg:hidden">{cta}</div>
    </div>
  );
}
